import { ReportColor } from '@/types/transmissionReport';
import type { TransmissionReport } from '@/types/transmissionReport';

const REPORT_TYPE_LABELS: Record<string, string> = {
  ALERT_ONLY: 'Non-routine',
  COMBO: 'Combo (HF & Routine)',
  ROUTINE: 'Routine',
  ERI_TRACKING: 'ERI Tracking',
  HEART_FAILURE: 'Heart Failure',
  PHYSICIAN_REQUESTED: 'Physician Request'
};

export const ALERT_TYPE_META: Partial<Record<ReportColor, { color: string; label: string }>> = {
  [ReportColor.Red]: { color: 'red', label: 'Red Alert' },
  [ReportColor.Yellow]: { color: 'yellow', label: 'Yellow Alert' },
  [ReportColor.Green]: { color: 'green', label: 'No Alert' },
  [ReportColor.Gray]: { color: 'gray', label: 'Untriaged' }
};

export function getReportTypeLabel(reportType?: string | null): string {
  if (!reportType) return '—';
  return (
    REPORT_TYPE_LABELS[reportType] ??
    reportType
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase())
  );
}

export function getAlertTypeMeta(color?: ReportColor | string | null) {
  if (!color) return undefined;
  return ALERT_TYPE_META[color as ReportColor];
}

export function getReportVendorLabel(
  report?: Pick<TransmissionReport, 'deviceVendor' | 'matchDevice'> | null
): string {
  const raw = report?.deviceVendor?.vendorName ?? report?.matchDevice?.vendor ?? undefined;
  if (!raw) return '—';
  return raw.trim();
}

export function getReportDeviceTypeLabel(
  report?: Pick<TransmissionReport, 'device' | 'matchDevice'> | null
): string {
  const deviceType = report?.device?.deviceType ?? report?.matchDevice?.type;
  if (!deviceType || deviceType === 'no_device_type') return '—';
  return deviceType === 'PM' ? 'Pacemaker' : deviceType;
}

export function getIsReportBillable(
  report?: Pick<TransmissionReport, 'billing' | 'isBillable'> | null
): boolean {
  return report?.billing?.isBillable ?? report?.isBillable ?? false;
}
